import type { MaskedTile as Tile } from '@completto/shared';
import { html, View } from 'rune-ts';
import type { PoolFilterMode } from '../../stores/index.ts';
import { OpenPoolView } from './OpenPool.ts';

export type CenterAreaData = {
  poolTiles: readonly Tile[];
  placeablePoolTileIds: ReadonlySet<string>;
  poolEnabled: boolean;
  poolFilter: PoolFilterMode;
  onPoolChipClick: (tileId: string) => void;
  onPoolFilterChange: (mode: PoolFilterMode) => void;
};

export class CenterAreaView extends View<CenterAreaData> {
  override template() {
    const pool = new OpenPoolView({
      tiles: this.data.poolTiles,
      placeableTileIds: this.data.placeablePoolTileIds,
      enabled: this.data.poolEnabled,
      filter: this.data.poolFilter,
      onChipClick: this.data.onPoolChipClick,
      onFilterChange: this.data.onPoolFilterChange,
    });
    return html`
      <section class="center-area flex flex-col gap-3 min-w-0">
        ${pool}
      </section>
    `;
  }
}
